
export default {
	formatErrors: formatErrors
};

function formatErrors(errors) {
	return errors.reduce(addError, {});
}

function addError(errors, error) {
	var name = error.field[0];
	var remainder = error.field.slice(1);

	var existing = errors[name];
	if(!existing) existing = (errors[name] = []);

	existing.push({
		field: remainder,
		message: error.message
	});

	return errors;
}
